// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v_SLEyk1 {
  max-width: 900px;
  margin: 0 auto;
}

.PkNRAEtT {
  font-size: 28px;
  font-weight: 700;
  color: #e0e0e0;
  margin-bottom: 24px;
}

.t21fke8M,
.QzZpsfHY {
  text-align: center;
  padding: 48px 0;
  color: #888;
}

.QzZpsfHY {
  color: #ff6b6b;
}

.IyahPiJh {
  margin-bottom: 32px;
}

.NydrD0hV {
  font-size: 18px;
  font-weight: 600;
  color: #e0e0e0;
  margin-bottom: 12px;
}

.Wksjy4NL {
  color: #666;
  font-style: italic;
}

/* Metrics grid */
.H4GWdU54 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.FW591Qfx {
  background: #16213e;
  border: 1px solid #2a2a4a;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
}

.UCoBlYIj {
  font-size: 32px;
  font-weight: 700;
  color: #4ecca3;
}

.SEVoesdF {
  font-size: 12px;
  color: #888;
  margin-top: 4px;
}

/* Lessons table */
.mv35lzle {
  width: 100%;
  border-collapse: collapse;
}

.mv35lzle th,
.mv35lzle td {
  padding: 8px 12px;
  text-align: left;
  border-bottom: 1px solid #2a2a4a;
}

.mv35lzle th {
  color: #888;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.mv35lzle td {
  color: #e0e0e0;
  font-size: 14px;
}

.mv35lzle tbody tr:hover {
  background: rgba(78, 204, 163, 0.05);
}

/* Achievement bars */
.y8lSPO7J {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.HCoL3wFI {
  display: flex;
  align-items: center;
  gap: 12px;
}

.qaQ66KvM {
  width: 160px;
  font-size: 13px;
  color: #e0e0e0;
  flex-shrink: 0;
}

.OBAiHJ7o {
  flex: 1;
  height: 8px;
  background: #2a2a4a;
  border-radius: 4px;
  overflow: hidden;
}

.JWuN93b1 {
  height: 100%;
  background: #4ecca3;
  border-radius: 4px;
  transition: width 0.3s;
}

._eE_x7ys {
  width: 80px;
  font-size: 12px;
  color: #888;
  text-align: right;
  flex-shrink: 0;
}

/* XP Histogram */
.MqLGa_zz {
  display: flex;
  gap: 8px;
  align-items: flex-end;
  height: 160px;
  padding-bottom: 40px;
  position: relative;
}

.jtY4rRPK {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
}

.U8abftFp {
  flex: 1;
  width: 100%;
  display: flex;
  align-items: flex-end;
}

.UHQ9e0Dh {
  width: 100%;
  background: #4ecca3;
  border-radius: 4px 4px 0 0;
  min-height: 2px;
  transition: height 0.3s;
}

.BGyI9SRV {
  font-size: 11px;
  color: #888;
  margin-top: 6px;
  white-space: nowrap;
}

.n3Q52mqv {
  font-size: 12px;
  color: #4ecca3;
  font-weight: 600;
}

/* Growth chart */
._cXVCsI6 {
  display: flex;
  gap: 4px;
  align-items: flex-end;
  height: 120px;
  padding-bottom: 36px;
  overflow-x: auto;
}

.wLkGuAHh {
  min-width: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
}

.YJBTbKBs {
  flex: 1;
  width: 100%;
  display: flex;
  align-items: flex-end;
}

.dbrW5s53 {
  width: 100%;
  background: #4ecca3;
  border-radius: 3px 3px 0 0;
  min-height: 2px;
  transition: height 0.3s;
}

._kSjgNUi {
  font-size: 10px;
  color: #666;
  margin-top: 4px;
  white-space: nowrap;
}

.toqUNIGN {
  font-size: 10px;
  color: #888;
}

/* Responsive */
@media (max-width: 800px) {
  .H4GWdU54 {
    grid-template-columns: repeat(2, 1fr);
  }

  .UCoBlYIj {
    font-size: 24px;
  }

  .qaQ66KvM {
    width: 100px;
    font-size: 11px;
  }

  .mv35lzle {
    font-size: 12px;
  }

  .mv35lzle th,
  .mv35lzle td {
    padding: 6px 8px;
  }
}

/* Responsive: 480px phone breakpoint */
@media (max-width: 480px) {
  .PkNRAEtT {
    font-size: 20px;
  }

  .H4GWdU54 {
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }

  .UCoBlYIj {
    font-size: 20px;
  }

  .qaQ66KvM {
    width: 80px;
    font-size: 10px;
  }

  ._eE_x7ys {
    width: 50px;
    font-size: 11px;
  }

  .mv35lzle th,
  .mv35lzle td {
    padding: 4px 6px;
    font-size: 11px;
  }

  .MqLGa_zz {
    height: 120px;
    gap: 4px;
  }

  ._cXVCsI6 {
    height: 100px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Admin.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;EACrB,aAAa;EACb,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,WAAW;EACX,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;EACrB,aAAa;EACb,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,WAAW;EACX,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,eAAe;AACf;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".container {\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.title {\n  font-size: 28px;\n  font-weight: 700;\n  color: #e0e0e0;\n  margin-bottom: 24px;\n}\n\n.loading,\n.error {\n  text-align: center;\n  padding: 48px 0;\n  color: #888;\n}\n\n.error {\n  color: #ff6b6b;\n}\n\n.section {\n  margin-bottom: 32px;\n}\n\n.sectionTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: #e0e0e0;\n  margin-bottom: 12px;\n}\n\n.empty {\n  color: #666;\n  font-style: italic;\n}\n\n/* Metrics grid */\n.metricsGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n}\n\n.metricCard {\n  background: #16213e;\n  border: 1px solid #2a2a4a;\n  border-radius: 8px;\n  padding: 16px;\n  text-align: center;\n}\n\n.metricValue {\n  font-size: 32px;\n  font-weight: 700;\n  color: #4ecca3;\n}\n\n.metricLabel {\n  font-size: 12px;\n  color: #888;\n  margin-top: 4px;\n}\n\n/* Lessons table */\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table th,\n.table td {\n  padding: 8px 12px;\n  text-align: left;\n  border-bottom: 1px solid #2a2a4a;\n}\n\n.table th {\n  color: #888;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.table td {\n  color: #e0e0e0;\n  font-size: 14px;\n}\n\n.table tbody tr:hover {\n  background: rgba(78, 204, 163, 0.05);\n}\n\n/* Achievement bars */\n.achievementList {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.achievementRow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.achievementName {\n  width: 160px;\n  font-size: 13px;\n  color: #e0e0e0;\n  flex-shrink: 0;\n}\n\n.achievementBar {\n  flex: 1;\n  height: 8px;\n  background: #2a2a4a;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.achievementFill {\n  height: 100%;\n  background: #4ecca3;\n  border-radius: 4px;\n  transition: width 0.3s;\n}\n\n.achievementRate {\n  width: 80px;\n  font-size: 12px;\n  color: #888;\n  text-align: right;\n  flex-shrink: 0;\n}\n\n/* XP Histogram */\n.histogram {\n  display: flex;\n  gap: 8px;\n  align-items: flex-end;\n  height: 160px;\n  padding-bottom: 40px;\n  position: relative;\n}\n\n.histogramBar {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n}\n\n.histogramFillWrap {\n  flex: 1;\n  width: 100%;\n  display: flex;\n  align-items: flex-end;\n}\n\n.histogramFill {\n  width: 100%;\n  background: #4ecca3;\n  border-radius: 4px 4px 0 0;\n  min-height: 2px;\n  transition: height 0.3s;\n}\n\n.histogramLabel {\n  font-size: 11px;\n  color: #888;\n  margin-top: 6px;\n  white-space: nowrap;\n}\n\n.histogramCount {\n  font-size: 12px;\n  color: #4ecca3;\n  font-weight: 600;\n}\n\n/* Growth chart */\n.growthChart {\n  display: flex;\n  gap: 4px;\n  align-items: flex-end;\n  height: 120px;\n  padding-bottom: 36px;\n  overflow-x: auto;\n}\n\n.growthBar {\n  min-width: 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n}\n\n.growthFillWrap {\n  flex: 1;\n  width: 100%;\n  display: flex;\n  align-items: flex-end;\n}\n\n.growthFill {\n  width: 100%;\n  background: #4ecca3;\n  border-radius: 3px 3px 0 0;\n  min-height: 2px;\n  transition: height 0.3s;\n}\n\n.growthLabel {\n  font-size: 10px;\n  color: #666;\n  margin-top: 4px;\n  white-space: nowrap;\n}\n\n.growthCount {\n  font-size: 10px;\n  color: #888;\n}\n\n/* Responsive */\n@media (max-width: 800px) {\n  .metricsGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .metricValue {\n    font-size: 24px;\n  }\n\n  .achievementName {\n    width: 100px;\n    font-size: 11px;\n  }\n\n  .table {\n    font-size: 12px;\n  }\n\n  .table th,\n  .table td {\n    padding: 6px 8px;\n  }\n}\n\n/* Responsive: 480px phone breakpoint */\n@media (max-width: 480px) {\n  .title {\n    font-size: 20px;\n  }\n\n  .metricsGrid {\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n  }\n\n  .metricValue {\n    font-size: 20px;\n  }\n\n  .achievementName {\n    width: 80px;\n    font-size: 10px;\n  }\n\n  .achievementRate {\n    width: 50px;\n    font-size: 11px;\n  }\n\n  .table th,\n  .table td {\n    padding: 4px 6px;\n    font-size: 11px;\n  }\n\n  .histogram {\n    height: 120px;\n    gap: 4px;\n  }\n\n  .growthChart {\n    height: 100px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `v_SLEyk1`,
	"title": `PkNRAEtT`,
	"loading": `t21fke8M`,
	"error": `QzZpsfHY`,
	"section": `IyahPiJh`,
	"sectionTitle": `NydrD0hV`,
	"empty": `Wksjy4NL`,
	"metricsGrid": `H4GWdU54`,
	"metricCard": `FW591Qfx`,
	"metricValue": `UCoBlYIj`,
	"metricLabel": `SEVoesdF`,
	"table": `mv35lzle`,
	"achievementList": `y8lSPO7J`,
	"achievementRow": `HCoL3wFI`,
	"achievementName": `qaQ66KvM`,
	"achievementBar": `OBAiHJ7o`,
	"achievementFill": `JWuN93b1`,
	"achievementRate": `_eE_x7ys`,
	"histogram": `MqLGa_zz`,
	"histogramBar": `jtY4rRPK`,
	"histogramFillWrap": `U8abftFp`,
	"histogramFill": `UHQ9e0Dh`,
	"histogramLabel": `BGyI9SRV`,
	"histogramCount": `n3Q52mqv`,
	"growthChart": `_cXVCsI6`,
	"growthBar": `wLkGuAHh`,
	"growthFillWrap": `YJBTbKBs`,
	"growthFill": `dbrW5s53`,
	"growthLabel": `_kSjgNUi`,
	"growthCount": `toqUNIGN`
};
export default ___CSS_LOADER_EXPORT___;
